export const MODULE_NOT_AVAILABLE_STORAGE_KEY = "module_not_available";

export const MODULE_NOT_AVAILABLE_ERROR = "module_not_available";

export function setModuleNotAvailablePayload(payload) {
  sessionStorage.setItem(
    MODULE_NOT_AVAILABLE_STORAGE_KEY,
    JSON.stringify(payload)
  );
}

export function getModuleNotAvailablePayload() {
  try {
    const raw = sessionStorage.getItem(MODULE_NOT_AVAILABLE_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearModuleNotAvailablePayload() {
  sessionStorage.removeItem(MODULE_NOT_AVAILABLE_STORAGE_KEY);
}
